import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mes <strong className="purple">Vidéos</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              youtubeLink="https://www.youtube.com/embed/57TEBlw9jG0"
              isBlog={false}
              
              description= "Vidéo réalisée en 2021, avec un style de montage « edit » très dynamique, différent de mes projets plus récents. L'intégralité du montage a été effectuée sur After Effects, sans passer par Premiere Pro. J’ai utilisé l’outil caméra 3D pour créer des effets de profondeur synchronisés avec la musique, notamment à travers l’animation typographique. Le personnage du jeu vidéo a été détouré sur quelques secondes afin d’apporter un effet d’animation stylisé. La colorimétrie a été retravaillée à l’aide de Magic Bullet Looks pour renforcer l’ambiance visuelle propre à ce type de montage."
              ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              youtubeLink="https://www.youtube.com/embed/dXAKus0BEoI"
              isBlog={false}
              description="Pour cette introduction vidéo, j’ai réalisé un dérushage dynamique afin de capter immédiatement l’attention du spectateur. Un changement d’ambiance intervient à 00:10, en lien direct avec le contexte narratif. La musique choisie soutient l'intrigue et renforce l’atmosphère tout en maintenant l’intérêt."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              youtubeLink="https://www.youtube.com/embed/PVWERfFcC50"
              isBlog={false}
              description="Dans cet extrait, j’ai commencé par le dérushage, puis ajouté une musique douce pour accompagner la séquence explicative. J’ai alterné entre des images d’archives et des plans facecam, agrémentés de légers zooms constants afin de maintenir un rythme dynamique. J’ai également intégré des animations de texte réalisées sur After Effects, avec un fond animé issu du pack RTFX, pour appuyer visuellement certaines informations clés."
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              youtubeLink="https://www.youtube.com/embed/T_ASOaxgXCg"
              isBlog={false}
              description="« Pour cette vidéo, j’ai d’abord effectué un dérushage de la voix afin de dynamiser le rythme du montage. J’ai ensuite expérimenté une séquence en motion design, une première pour moi. Une musique douce a été choisie pour instaurer une ambiance onirique, renforçant le ton du récit. Enfin, des vidéos issues de banques d’images ont été sélectionnées avec soin pour illustrer et enrichir la narration vocale. "
             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              youtubeLink="https://www.youtube.com/embed/vbCPRuGU97I"
              isBlog={false}
              description="J’ai commencé par un dérush complet de la voix off et des séquences vidéo. J’ai ensuite intégré une musique calme et intrigante, puis sélectionné des plans issus d’une banque d’images, que j’ai alternés avec des prises facecam. Afin de dynamiser l’ensemble, j’ai appliqué de légers zooms sur chaque extrait. Lors des parties explicatives, j’ai ajouté des textes animés ainsi que des flèches dont la vitesse a été ajustée via l’éditeur de courbes d’After Effects, pour un rendu fluide. Un effet Deep Glow a également été utilisé pour apporter de la brillance aux éléments textuels."
             
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
